import { FC } from 'react';
import { useUIStore } from '@/stores';
import { EstimateModals } from '@/widgets/modals/EstimateModals';
import { RecipeModals } from '@/widgets/modals/RecipeModals';

export const RenderManager: FC = () => {
  const activeModal = useUIStore((s) => s.activeModal);

  if (!activeModal) return null;

  return (
    <>
      <EstimateModals />
      <RecipeModals />
    </>
  );
};